export default __webpack_public_path__ + "fonts/non-subscriber.svg";